import classNames from 'classnames';
import { createRef, PureComponent } from 'react';

import Latex from 'my-elements/Latex';

import EquationEditor from './EquationEditor';

export default class EquationBlock extends PureComponent {
  state = { showEditor: false };
  wrapper = createRef();

  componentDidMount() {
    const { block, blockProps, contentState } = this.props;
    const active = block.getKey() === blockProps.focusedBlockKey;
    if (active) {
      this.setState({ showEditor: true });
    }

    if (contentState.getEntity(block.getEntityAt(0)).getData().init) {
      this.updateEntityData({ latex: '' });
      this.showEditor();
    }
  }
  componentDidUpdate(prevProps) {
    const active = this.props.block.getKey() === this.props.blockProps.focusedBlockKey;
    const prevActive = prevProps.block.getKey() === prevProps.blockProps.focusedBlockKey;
    if (active && !prevActive) {
      this.setState({ showEditor: true });
    }
  }

  getLatex() {
    const { block, contentState } = this.props;
    return contentState.getEntity(block.getEntityAt(0)).getData().latex;
  }

  updateEntityData = data => {
    const { block, blockProps, contentState } = this.props;
    const entityKey = block.getEntityAt(0);
    const updatedContentState = contentState.replaceEntityData(entityKey, data);
    blockProps.onUpdateContentState(updatedContentState);
  };

  updateLatex = latex => this.updateEntityData({ latex });

  showEditor = () => {
    const { block, blockProps } = this.props;
    blockProps.onFocus('EQUATION', block.getKey());
    // this.setState({ showEditor: true });
  };
  closeEditor = () => {
    const { blockProps } = this.props;
    blockProps.onBlur();
    this.setState({ showEditor: false });
    blockProps.onResetFocus?.();
  };

  render() {
    const { blockProps } = this.props;
    const { readOnly, reportLatexErrors } = blockProps;
    const { showEditor } = this.state;
    const latex = this.getLatex();

    return (
      <>
        <div
          className={classNames({ editable: !readOnly })}
          css={wrapperCss}
          onClick={!readOnly ? this.showEditor : undefined}
          ref={this.wrapper}
        >
          <Latex displayMode reportErrors={reportLatexErrors}>
            {latex}
          </Latex>
        </div>
        {!readOnly && showEditor && Boolean(this.wrapper.current) && (
          <EquationEditor
            anchorEl={this.wrapper.current}
            displayMode
            onClose={this.closeEditor}
            onUpdate={this.updateLatex}
            value={latex}
          />
        )}
      </>
    );
  }
}

const wrapperCss = () => ({
  width: '100%',
  overflow: 'hidden', // prevent .katex-display margin overflow (causes white-space in consecutive solution blocks)
  '.katex-display > .katex': {
    whiteSpace: 'normal', // allow equations to wrap
    overflowX: 'auto',
    overflowY: 'hidden', // this overflowX causes vertical scrollbars for some equations (ex. \frac{1}{2})
  },

  '&.editable': {
    cursor: 'pointer',
  },
});
